import type { SubscriptionTier } from '@/stores/subscription'

const TIER_LABEL: Record<SubscriptionTier, string> = {
  basis: 'Basis',
  standaard: 'Standaard',
  premium: 'Premium',
}

// Chargee subscription tiers, restyled with the easyEnergy palette: Basis is
// teal, Standaard uses the orange gradient and Premium is dark navy.
const TIER_BG: Record<SubscriptionTier, string> = {
  basis: 'bg-medium-purple',
  standaard: 'bg-premium-gradient bg-cover bg-center',
  premium: 'bg-dark-blue',
}

export function TierBadge({
  tier,
  className,
  title,
}: {
  tier: SubscriptionTier
  className?: string
  title?: string
}) {
  return (
    <span className={`tier-badge ${TIER_BG[tier]} ${className ?? ''}`} title={title}>
      {TIER_LABEL[tier]}
    </span>
  )
}
